const initialState = {
  recaptchavalid: false,
  emailusernamevalid: false,
  resetPasswordInProgress: false,
  resetPasswordComplete: false,
  resetPasswordError: false,
  resetPasswordErrorText: "",
  newPasswordInProgress: false,
  newPasswordComplete: false,
  newPasswordError: false,
  newPasswordErrorText: "",
};

const resetPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case "RESETPASSWORD_RECAPTCHA_VALID":
    case "RESETPASSWORD_RECAPTCHA_INVALID":
      state = {
        ...state,
        recaptchavalid:
          action.type === "RESETPASSWORD_RECAPTCHA_VALID" ? true : false,
      };
      break;
    case "RESETPASSWORD_EMAILUSERNAME_VALID":
    case "RESETPASSWORD_EMAILUSERNAME_INVALID":
      state = {
        ...state,
        emailusernamevalid:
          action.type === "RESETPASSWORD_EMAILUSERNAME_VALID" ? true : false,
      };
      break;
    case "RESETPASSWORD_INIT":
      state = {
        ...state,
        resetPasswordInProgress: true,
        resetPasswordComplete: false,
        resetPasswordError: false,
      };
      break;
    case "RESETPASSWORD_SUCCESS":
      state = {
        ...state,
        resetPasswordInProgress: false,
        resetPasswordComplete: true,
        resetPasswordError: false,
      };
      break;
    case "RESETPASSWORD_CLEAR":
      state = {
        ...state,
        resetPasswordInProgress: false,
        resetPasswordComplete: false,
        resetPasswordError: false,
      };
      break;
    case "RESETPASSWORD_ERROR":
      state = {
        ...state,
        resetPasswordInProgress: false,
        resetPasswordComplete: false,
        resetPasswordError: true,
        resetPasswordErrorText: action.payload,
      };
      break;
    case "NEWPASSWORD_RESET":
      state = {
        ...state,
        newPasswordInProgress: false,
        newPasswordComplete: false,
        newPasswordError: false,
        newPasswordErrorText: "",
      };
      break;
    case "NEWPASSWORD_INIT":
      state = {
        ...state,
        newPasswordInProgress: true,
        newPasswordComplete: false,
        newPasswordError: false,
      };
      break;
    case "NEWPASSWORD_SUCCESS":
      state = {
        ...state,
        newPasswordInProgress: false,
        newPasswordComplete: true,
        newPasswordError: false,
      };
      break;
    case "NEWPASSWORD_ERROR":
      state = {
        ...state,
        newPasswordInProgress: false,
        newPasswordComplete: false,
        newPasswordError: true,
        newPasswordErrorText: action.payload,
      };
      break;
    default:
      break;
  }
  return state;
};

export default resetPasswordReducer;



// WEBPACK FOOTER //
// ./src/reducers/resetPasswordReducer.js